<section class="page">
  <header class="page-header">
    <h2>Capteurs en cours de livraison</h2>
    <p class="subtitle">Liste les capteurs dont le statut d'envoi est actuellement en cours de transit.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-stocks/capteurs/voir">Aller vers capteurs</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des capteurs en cours de livraison...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucun capteur en cours de livraison.</p>
    } @else {
      <p class="meta">{{ items.length }} capteur(s) en transit.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Numéro de série</th>
              <th>Référence envoi</th>
              <th>Cartouches</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.numero_serie }}</td>
                <td>{{ item.reference_envoi || '-' }}</td>
                <td>{{ formatCartouches(item) || '-' }}</td>
                <td>{{ item.statut_livraison_envoi_nom || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>
